import { render, staticRenderFns } from "./TransferLineOfficialAccountMoveInfo.vue?vue&type=template&id=9d50482e&scoped=true&"
import script from "./TransferLineOfficialAccountMoveInfo.vue?vue&type=script&lang=js&"
export * from "./TransferLineOfficialAccountMoveInfo.vue?vue&type=script&lang=js&"
import style0 from "./TransferLineOfficialAccountMoveInfo.vue?vue&type=style&index=0&id=9d50482e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d50482e",
  null
  
)

export default component.exports